import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { colors } from '../constants';
const styleOverrides = {
  root: {
    'label + &': {
      marginTop: 20
    },
    'input::placeholder, textarea::placeholder': {
      color: colors.action.disabled,
      opacity: 1,
      transition: 'none'
    },
    borderRadius: 5,
    [`&.Mui-disabled .${outlinedInputClasses.notchedOutline}`]: {
      border: 'none'
    },
    '&.Mui-disabled': {
      backgroundColor: colors.oriGrey[100]
    },
    [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
      borderWidth: 1
    },
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: colors.text.disabled
    }
  },
  input: {
    padding: '15px 15px'
  },
  adornedStart: {
    '& .MuiInputBase-input': {
      paddingLeft: 0
    }
  },
  adornedEnd: {
    '& .MuiInputBase-input': {
      paddingRight: 0
    }
  },
  notchedOutline: {
    top: 0,
    background: 'unset',
    '& legend': {
      maxWidth: 0
    }
  },
  multiline: {
    padding: '15px 25px 15px 15px'
  }
};
export default {
  styleOverrides
};